<template>
    <div height="medium" width="large">
        <div>
            <h2 class="heading">{{ $t('modals.patient_profile.profile.detail_form.tabs.request') }}</h2>
            <div class="request-container">
                <h4 class="title">{{ $t('modals.patient_profile.profile.request.card_head') }}</h4>

                <request-tabs :activeTab="activeTab" @toggle="toggleTab"></request-tabs>
                <div class="tab-content">
                    <request-tab-content
                        :activeTab="activeTab"
                        :availHipaaForms="availHipaaForms"
                        @refresh-record-request="getPatientRecordRequest"
                        @refresh-hipaa="$emit('refresh-hipaa')"
                    ></request-tab-content>
                </div>
            </div>
            <record-form :patientRecordRequests="patientRecordRequests" :availHipaaForms="availHipaaForms"></record-form>
        </div>
    </div>
</template>

<script>
    import FormMixin from 'mixins/FormMixin'
    import HandleRequestMixin from 'mixins/HandleRequestMixin'
    import RequestTabs from 'components/forms/patient/RequestTabs'
    import RequestTabContent from 'components/forms/patient/RequestTabContent'
    import RecordForm from 'components/forms/record-request/RecordForm'
    import PatientRecordsAPI from '../../../api/PatientRecordsAPI'

    export default {
        mixins: [FormMixin, HandleRequestMixin],
        components: {
            RecordForm,
            RequestTabs,
            RequestTabContent,
        },
        props: {
            availHipaaForms: { type: Array, required: true },
        },
        data() {
            return {
                activeTab: 'network',
                patientRecordRequests: [],
            }
        },
        methods: {
            toggleTab(name) {
                this.activeTab = name
            },

            getPatientRecordRequest() {
                PatientRecordsAPI.getPatientRecordRequest(
                    this.$auth.getActiveMember()?.id,
                    this.$auth.getUser()?.practiceId,
                    this.$route.params.id,
                ).then((res) => {
                    this.patientRecordRequests = res
                })
            },
        },

        mounted() {
            this.getPatientRecordRequest()
        },
    }
</script>
<style scoped lang="scss">
    @import 'styles/setup/_variables.scss';
    .heading {
        font-size: 16px;
        color: oklch(0.21 0.034 264.665);
        font-weight: 500;
        margin-bottom: 14px;
    }
    .request-container {
        padding: 20px 28px;
        border-radius: 12px;
        border: 1px solid #ddd;
        margin-bottom: 20px;
        background-color: #fff;
    }
    .title {
        font-weight: 400;
        color: $color-black;
        margin-bottom: 20px;
    }
</style>
